var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-item"},[_c('span',{class:_vm.timeslotType},[_vm._v(_vm._s(_vm.timeSlot))]),_c('AppNumberInput',{attrs:{"value":_vm.price.value,"max":999999}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }